module.exports = __webpack_public_path__ + "img/about_banner.2999b250.jpg";